/* eslint-disable */
/*-----------------------------------------------
|       Navbar Init
-----------------------------------------------*/


const navbarInit = () => {

  const Selector = {
    SIDEBAR_CLOSE: "[data-sidebar-close='sidebar-close']",
    BASE_CONTENT: "[data-base-content='home'],[data-base-content='nav']",
    PAGE: '.page',
    GALLERY_SWIPER: '.gallerySwiper',
    PAGE_LINK: "[data-sidebar-link='page-link']",
    PORTFOLIO_GALLERY: "#portfolio-gallery"
  };

  const ClassName = {
    TRANSITION_NONE: 'transition-none',
    PAGE: 'page',
    DISPLAY_NONE: 'd-none'
  };

  const PRIMARY_VIEW_IDS = new Set([
    'triage',
    'howitworks',
    'resources',
    'contact',
  ]);

  const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const events = {
    SHOW_OFFCANVAS: 'show.bs.offcanvas',
    SHOWN_OFFCANVAS: 'shown.bs.offcanvas',
    HIDE_OFFCANVAS: 'hide.bs.offcanvas',
    HIDDEN_OFFCANVAS: 'hidden.bs.offcanvas',
  }

  const closeBtnsList = Array.from(document.querySelectorAll(Selector.SIDEBAR_CLOSE));
  const baseContentElList = Array.from(document.querySelectorAll(Selector.BASE_CONTENT));
  const pageList = Array.from(document.querySelectorAll(Selector.PAGE));
  const portfolioGallery = document.querySelector(Selector.PORTFOLIO_GALLERY)
  const swipers = Array.from(document.querySelectorAll(Selector.GALLERY_SWIPER));

  const location = window.location
  const history = window.history

  const reduceReveal = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsInert = 'inert' in HTMLElement.prototype;

  let activePage = null;
  let lastRevealTrigger = null;
  let pendingRevealTrigger = null;

  if (reduceReveal) {
    document.documentElement.classList.add('tt-reduced-reveal');
  }

  const baseContentList = baseContentElList.map(
    el => window.bootstrap.Offcanvas.getInstance(el)
  );

  const showBaseContents = () => {
    baseContentList.forEach(item => {
      item.show();
    });
  }

  const hideBaseContents = () => {
    baseContentList.forEach(item => {
      item.hide();
    });
  }

  const addTransitions = () => {
    baseContentElList.forEach(el => {
      el.classList.remove('transition-none')
    })
  }

  const setBodyPointersEvent = (event) => {
    document.body.style.pointerEvents = event
  }


  const removeTransitions = () => {
    baseContentElList.forEach(el => {
      el.classList.add('transition-none')
    })
  }

  const setRegionInert = (el, inert) => {
    if (!el) {
      return;
    }

    if (supportsInert) {
      el.inert = inert;
      if (inert) {
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('aria-hidden');
      }
      return;
    }

    if (inert) {
      el.setAttribute('aria-hidden', 'true');
      el.querySelectorAll(FOCUSABLE_SELECTOR).forEach(focusable => {
        if (focusable.dataset.ttTabindex === undefined) {
          focusable.dataset.ttTabindex = focusable.getAttribute('tabindex') ?? '';
        }
        focusable.setAttribute('tabindex', '-1');
      });
    } else {
      el.removeAttribute('aria-hidden');
      el.querySelectorAll('[data-tt-tabindex]').forEach(focusable => {
        const stored = focusable.dataset.ttTabindex;
        if (stored === '') {
          focusable.removeAttribute('tabindex');
        } else {
          focusable.setAttribute('tabindex', stored);
        }
        delete focusable.dataset.ttTabindex;
      });
    }
  }

  const syncRevealAccessibility = (currentActivePage) => {
    activePage = currentActivePage;

    baseContentElList.forEach(el => {
      setRegionInert(el, !!currentActivePage);
    });

    pageList.forEach(page => {
      setRegionInert(page, !currentActivePage || page !== currentActivePage);
    });
  }

  const isFocusInHiddenRegion = () => {
    const focused = document.activeElement;
    if (!focused || focused === document.body) {
      return false;
    }

    if (supportsInert) {
      return !!focused.closest('[inert]');
    }

    return !!focused.closest('[aria-hidden="true"]');
  }

  const getCloseButton = (page) => page.querySelector('.sticky-area button[aria-label="Close"]');

  const focusOpenView = (page) => {
    requestAnimationFrame(() => {
      const closeBtn = getCloseButton(page);
      if (closeBtn) {
        closeBtn.focus();
        return;
      }
      const firstFocusable = page.querySelector(FOCUSABLE_SELECTOR);
      if (firstFocusable) {
        firstFocusable.focus();
      }
    });
  }

  const focusHome = () => {
    requestAnimationFrame(() => {
      const trigger = lastRevealTrigger;
      if (trigger && document.contains(trigger)) {
        trigger.focus();
        return;
      }
      const navCard = document.querySelector('.tt-home-nav-card');
      if (navCard) {
        navCard.focus();
        return;
      }
      const heroCta = document.querySelector('.tt-home-cta');
      if (heroCta) {
        heroCta.focus();
      }
    });
  }

  const showPage = (page) => {
    page.classList.remove('d-none');
    if (reduceReveal) {
      page.style.opacity = 1;
      return;
    }

    const duration = 500;
    page.style.opacity = 0;
    let last = +new Date();
    const fadeIn = () => {
      page.style.opacity = +page.style.opacity + (new Date() - last) / duration;
      last = +new Date();
      if (+page.style.opacity < 1) {
        (window.requestAnimationFrame && requestAnimationFrame(fadeIn)) || setTimeout(fadeIn, 16);
      }
    };
    fadeIn();
  }

  const hidePage = (page) => {
    page.classList.add('d-none');
    page.style.opacity = 0;
  }

  const hideAllPages = () => {
    pageList.forEach(page => {
      hidePage(page);
    });
  }

  const normalizePrimaryHash = (rawHash) => {
    const value = rawHash || location.hash || '';
    if (!value || value === '#!' || value === '#') {
      return '';
    }
    const id = value.startsWith('#') ? value.slice(1) : value;
    if (PRIMARY_VIEW_IDS.has(id)) {
      return `#${id}`;
    }
    return '';
  }

  const getPageFromHash = (hash) => {
    if (!hash) {
      return null;
    }
    const target = document.querySelector(hash);
    if (!target) {
      return null;
    }
    return target.closest(Selector.PAGE);
  }

  const applyViewFromHash = (rawHash, focusIntent = 'auto') => {
    const hash = normalizePrimaryHash(rawHash);
    hideAllPages();

    const currentPage = getPageFromHash(hash);
    if (currentPage) {
      hideBaseContents();
      window.scrollTo(0, 0);
      showPage(currentPage);
      syncRevealAccessibility(currentPage);

      const shouldFocusOpen = focusIntent === 'open'
        || (focusIntent === 'auto' && (pendingRevealTrigger || isFocusInHiddenRegion()));

      if (pendingRevealTrigger) {
        lastRevealTrigger = pendingRevealTrigger;
        pendingRevealTrigger = null;
      }

      if (shouldFocusOpen) {
        focusOpenView(currentPage);
      }
      return;
    }

    showBaseContents();
    syncRevealAccessibility(null);

    const shouldFocusHome = focusIntent === 'close'
      || (focusIntent === 'auto' && isFocusInHiddenRegion());

    if (shouldFocusHome) {
      focusHome();
    }
  }

  const runAfterRouteChange = () => {
    if (portfolioGallery && window.Isotope) {
      window.Isotope.data(portfolioGallery).arrange()
    }

    swipers.forEach(el => {
      if (el.swiper) {
        el.swiper.update();
      }
    });
  }

  const closeToHome = () => {
    const urlWithoutHash = `${location.pathname}${location.search}`;
    if (location.hash) {
      history.pushState(null, '', urlWithoutHash);
    }
    applyViewFromHash('', 'close');
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) {
      return;
    }
    const href = link.getAttribute('href');
    if (!href || href.length < 2) {
      return;
    }
    const id = href.slice(1);
    if (PRIMARY_VIEW_IDS.has(id)) {
      pendingRevealTrigger = link;
    }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !activePage) {
      return;
    }
    e.preventDefault();
    closeToHome();
  });

  const load = () => {
    showBaseContents();
    removeTransitions();
    applyViewFromHash(location.hash, location.hash ? 'open' : 'auto');
    addTransitions();

    closeBtnsList.forEach(item => {
      item.addEventListener('click', e => {
        if (!e.target.closest(Selector.PAGE_LINK)) {
          closeToHome();
        }
      });
    });
  }

  load();

  baseContentElList.forEach(item => {
    item.addEventListener(events.SHOW_OFFCANVAS, () => {
      setBodyPointersEvent('none')
    })
    item.addEventListener(events.HIDE_OFFCANVAS, () => {
      setBodyPointersEvent('none')
    })
    item.addEventListener(events.SHOWN_OFFCANVAS, () => {
      setBodyPointersEvent('all')
    })
    item.addEventListener(events.HIDDEN_OFFCANVAS, () => {
      setBodyPointersEvent('all')
    })
  })

  window.addEventListener('hashchange', () => {
    const focusIntent = pendingRevealTrigger ? 'open' : 'auto';
    applyViewFromHash(location.hash, focusIntent);
    runAfterRouteChange();
  });

  window.addEventListener('popstate', () => {
    applyViewFromHash(location.hash, 'auto');
    runAfterRouteChange();
  });
};

export default navbarInit;
